export const comments = [
  {
    changedUtc: '2019-03-28T21:13:00.6465381',
    content: 'aasadasd @[@adminUser](1105)',
    createdByUser: { firstName: 'Kip', lastName: 'Hudson' },
    createdByUserId: 1008,
    id: '1117',
    wasEdited: false
  },
  {
    changedUtc: '2019-03-28T21:13:00.6465381',
    content:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse lorem dolor sit amet, laboris exercitation enim dolor sit amet ullamco',
    createdByUser: { firstName: 'Kip', lastName: 'Hudson' },
    createdByUserId: 1008,
    id: '1117',
    wasEdited: true
  },
  {
    changedUtc: '2019-03-28T21:13:00.6465381',
    content: 'aasadasd @[@adminUser](1105)',
    createdByUser: { firstName: 'Kip', lastName: 'Hudson' },
    createdByUserId: 1008,
    id: '1117',
    wasEdited: false
  },
  {
    changedUtc: '2019-03-28T21:13:00.6465381',
    content:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse lorem dolor sit amet, laboris exercitation enim dolor sit amet ullamco',
    createdByUser: { firstName: 'Kip', lastName: 'Hudson' },
    createdByUserId: 1008,
    id: '1117',
    wasEdited: true
  }
];

export const users = [
  {
    display: '@adminUser',
    firstName: 'John',
    id: '1105',
    lastName: 'Doe'
  }
];

export const activities = [
  {
    actualUser: 'Zackery Shields',
    createdUtc: '2019-03-29T18:47:51.1035067',
    subTitle: null,
    title: 'Shipment created'
  },
  {
    actualUser: 'Zackery Shields',
    createdUtc: '2019-03-29T18:48:58.8148849',
    subTitle: null,
    title: 'Shipment billing address geocoded'
  },
  {
    actualUser: 'Zackery Shields',
    createdUtc: '2019-03-29T18:49:05.0744248',
    subTitle: null,
    title: 'Shipment stop geocoded'
  },
  {
    actualUser: 'Zackery Shields',
    createdUtc: '2019-03-29T18:49:06.2357317',
    subTitle: null,
    title: 'Shipment stop geocoded'
  }
];
